import React from 'react';
import PropTypes from 'prop-types';

import DialogRoundedModal from '../../../components/DialogRoundedModal';
import WeeklyCheckin from '../../Model/WeeklyCheckin';

import ClientWeightChart from './ClientWeightChart';
import texts from './texts.json';
import { WeightHistoryContainer } from './styles';

const ClientWeightChartModal = ({
  clientId,
  checkinDocs,
  showModal,
  onClose,
}) => (
  <DialogRoundedModal
    open={showModal}
    onClose={onClose}
    title={texts.weightHistory}
    maxWidth="lg"
  >
    <WeightHistoryContainer>
      <ClientWeightChart checkinDocs={checkinDocs} clientId={clientId} />
    </WeightHistoryContainer>
  </DialogRoundedModal>
);

ClientWeightChartModal.propTypes = {
  clientId: PropTypes.string,
  checkinDocs: PropTypes.arrayOf(PropTypes.instanceOf(WeeklyCheckin)),
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
};

ClientWeightChartModal.defaultProps = {
  clientId: null,
  checkinDocs: null,
  showModal: false,
  onClose: () => {},
};

export default ClientWeightChartModal;
